
import Vue from 'vue';
import fetchUserWidgets from './fetchUserWidgets';

const success = (resolve) => {
  fetchUserWidgets();
  resolve();
};

const failed = (error, reject) => { reject(error); };

export default (value) => {
  const data = new FormData();
  data.append('widgets', JSON.stringify(Object.assign([], value)).replace(/"([^"]+)":/g, '$1:'));
  const p = new Promise((resolve, reject) => {
    Vue.$http
    .request({
      url: 'user-widgets',
      data,
      method: 'post',
    }).then(() => {
      success(resolve);
    }).catch((error) => {
      failed(error, reject);
    });
  });
  return p;
};




// WEBPACK FOOTER //
// ./src/app/services/widgets/updateUserWidgets.js